import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { NumerologyInsights } from '../components/NumerologyInsights';
import { CallToAction } from '../components/CallToAction';
{/*import { Testimonials } from '../components/Testimonials';*/}
import { Footer } from '../components/Footer';

export const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <NumerologyInsights />
      <CallToAction />
      {/* <Testimonials /> */}
      <Footer />
    </div>
  );
};

export default LandingPage;